import React from "react";
import "./Text.scss"
const SubheaderText = ({ text, invert = false }) => {
    return (
        <div className={!invert ? "SubheaderText-Rewardstick" : "SubheaderText-Rewardstick-invert"}>{text}</div>
    )
}
export default SubheaderText